// src/pages/MyGrowthPage/components/LevelProgress.jsx
import React from "react";
import styled, { keyframes } from "styled-components";

const shimmer = keyframes`
  0% { background-position: -200px 0; }
  100% { background-position: 200px 0; }
`;

const LevelContainer = styled.div`
  border-radius: 20px;
  padding: 30px;
  margin-bottom: 40px;
  border: 1px solid rgba(255, 255, 255, 0.05);
  background: var(--secondaryBackgroundColor);
  transition: 0.5s;
`;

const LevelHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 25px;

  h2 {
    font-size: 1.8rem;
    font-weight: 700;
    margin: 0;
    color: var(--fontPrimaryColor);
  }
`;

const LevelInfo = styled.div`
  text-align: center;
`;

const LevelNumber = styled.div`
  font-size: 4rem;
  font-weight: 800;
  background: linear-gradient(90deg, #ffd700, #ff9800);
  background-clip: text;
  -webkit-text-fill-color: transparent;
  line-height: 1;
`;

const LevelLabel = styled.div`
  font-size: 1rem;
  color: var(--fontSecondaryColor);
  margin-top: 5px;
`;

const XPProgress = styled.div`
  margin: 30px 0;
`;

const XPInfo = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  font-size: 0.9rem;
  color: var(--fontSecondaryColor);
`;

const XPMeter = styled.div`
  height: 12px;
  background: var(--thirdBackgroundColor);
  border-radius: 6px;
  overflow: hidden;
  position: relative;
`;

const XPFill = styled.div`
  height: 100%;
  width: ${(props) => props.percent}%;
  background: linear-gradient(90deg, #ffd700, #ff9800);
  border-radius: 6px;
  transition: width 1s ease-in-out;
  position: relative;
  overflow: hidden;

  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(
      90deg,
      transparent,
      rgba(255, 255, 255, 0.2),
      transparent
    );
    animation: ${shimmer} 2s infinite;
  }
`;

const LevelProgress = ({
  currentLevel,
  totalTasksCompleted,
  totalHabitsCompleted,
  totalPerfectDays,
}) => {
  return (
    <LevelContainer>
      <LevelHeader>
        <h2>Level Progress</h2>
        <LevelInfo>
          <LevelNumber>{currentLevel.level}</LevelNumber>
          <LevelLabel>{currentLevel.title}</LevelLabel>
        </LevelInfo>
      </LevelHeader>

      <XPProgress>
        <XPInfo>
          <span>{currentLevel.xpInCurrentLevel} XP</span>
          <span>Level {currentLevel.level}</span>
          <span>{currentLevel.xpForNextLevel} XP</span>
        </XPInfo>
        <XPMeter>
          <XPFill percent={currentLevel.progress} />
        </XPMeter>
        <div
          style={{
            textAlign: "center",
            marginTop: "10px",
            color: "var(--fontSecondaryColor)",
          }}
        >
          Total XP: {currentLevel.xp} • Next Level:{" "}
          {currentLevel.nextLevel || "MAX"}
        </div>
      </XPProgress>

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginTop: "30px",
        }}
      >
        <div style={{ textAlign: "center" }}>
          <div
            style={{
              fontSize: "1.8rem",
              fontWeight: "700",
              color: "#4caf50",
            }}
          >
            {totalTasksCompleted}
          </div>
          <div
            style={{
              fontSize: "0.9rem",
              color: "var(--fontSecondaryColor)",
            }}
          >
            Tasks Completed
          </div>
        </div>
        <div style={{ textAlign: "center" }}>
          <div
            style={{
              fontSize: "1.8rem",
              fontWeight: "700",
              color: "#2196f3",
            }}
          >
            {totalHabitsCompleted}
          </div>
          <div
            style={{
              fontSize: "0.9rem",
              color: "var(--fontSecondaryColor)",
            }}
          >
            Habits Maintained
          </div>
        </div>
        <div style={{ textAlign: "center" }}>
          <div
            style={{
              fontSize: "1.8rem",
              fontWeight: "700",
              color: "#ff9800",
            }}
          >
            {totalPerfectDays}
          </div>
          <div
            style={{
              fontSize: "0.9rem",
              color: "var(--fontSecondaryColor)",
            }}
          >
            Perfect Days
          </div>
        </div>
        <div style={{ textAlign: "center" }}>
          <div
            style={{
              fontSize: "1.8rem",
              fontWeight: "700",
              color: "#9c27b0",
            }}
          >
            {currentLevel.xp}
          </div>
          <div
            style={{
              fontSize: "0.9rem",
              color: "var(--fontSecondaryColor)",
            }}
          >
            Total XP Earned
          </div>
        </div>
      </div>
    </LevelContainer>
  );
};

export default LevelProgress;
